import { FormSelectInputOptionMeta } from "@Modules/core/types/FormMetaType";

export const ModuleOptions: FormSelectInputOptionMeta[] = [
  {
    value: "American Glob",
    label: 'American Glob',
  },
  {
    value: 'Archivage',
    label: 'Archivage',
  },
  {
    value: 'Bonus-Point Management',
    label: 'Bonus-Point Management',
  },
  {
    value: "Centre D'appel",
    label: "Centre D'appel",
  },
  {
    value: 'Chargeback',
    label: 'Chargeback',
  },
  {
    value: 'Fraud Acquirer',
    label: 'Fraud Acquirer',
  },
  {
    value: 'Gestion Carte à Puce',
    label: 'Gestion Carte à Puce',
  },
  {
    value: 'Gestion Clés HSM',
    label: 'Gestion Clés HSM',
  },
  {
    value: 'Gestion Commerçant',
    label: 'Gestion Commerçant',
  },
  {
    value: 'Gestion Débit',
    label: 'Gestion Débit',
  },
  {
    value: 'Gestion Fraude',
    label: 'Gestion Fraude',
  },
  {
    value: 'Gestion GAB',
    label: 'Gestion GAB',
  },
  {
    value: 'Gestion Interfaces',
    label: 'Gestion Interfaces',
  },
  {
    value: 'Gestion Porteurs',
    label: 'Gestion Porteurs',
  },
  {
    value: 'Gestion Prépayé',
    label: 'Gestion Prépayé',
  },
  {
    value: 'Gestion Transactions',
    label: 'Gestion Transactions',
  },
  {
    value: 'GIMAC',
    label: 'GIMAC',
  },
  {
    value: 'Local Interchange System',
    label: 'Local Interchange System',
  },
  {
    value: 'Mastercard',
    label: 'Mastercard',
  },
  {
    value: 'MDS',
    label: 'MDS',
  },
  {
    value: 'MDS Reconcialiation',
    label: 'MDS Reconcialiation',
  },
  {
    value: 'Migration',
    label: 'Migration',
  },
  {
    value: 'Online Fraud Issuer',
    label: 'Online Fraud Issuer',
  },
  {
    value: 'Paramètres de Base',
    label: 'Paramètres de Base',
  },
  {
    value: "Paramètres d'intégration",
    label: "Paramètres d'intégration",
  },
  {
    value: 'Paramètres du Système',
    label: 'Paramètres du Système',
  },
  {
    value: 'POS ISO',
    label: 'POS ISO',
  },
  {
    value: 'POS TLP',
    label: 'POS TLP',
  },
  {
    value: 'Revolving Credit',
    label: 'Revolving Credit',
  },
  {
    value: 'Scoring',
    label: 'Scoring',
  },
  {
    value: 'Select System',
    label: 'Select System',
  },
  {
    value: 'Single Message System',
    label: 'Single Message System',
  },
  {
    value: 'SMS Reconciliation',
    label: 'SMS Reconciliation',
  },
  {
    value: 'TPE CB2A',
    label: 'TPE CB2A',
  },
  {
    value: 'Traitement Des Batches',
    label: 'Traitement Des Batches',
  },
  {
    value: 'VISA BASE II',
    label: 'VISA BASE II',
  },
  {
    value: 'VISA BASE II - Reconciliation',
    label: 'VISA BASE II - Reconciliation',
  },
];
